/**
* @function priceCalculator
* @param 
* @description This function is used to calculate price based on  
*/

export function priceCalculator({price, discountPrice}) {
   return Number.parseFloat((price - ((discountPrice/100)*(price)))).toFixed(2)
}